module.exports = __webpack_public_path__ + "static/kevin-1a386e3023298ab01c64a7489496ae79.png";